/**
 * Parse an amount_display like "$4.99" or "SAR 29.00" into a number.
 * Returns null if parsing fails.
 */
export function parseAmount(displayStr) {
  if (!displayStr || typeof displayStr !== "string") return null;
  const num = displayStr.replace(/[^\d.]/g, "");
  const val = parseFloat(num);
  return Number.isFinite(val) ? val : null;
}

/**
 * Format a bundle-savings microcopy line given unit + bundle display strings
 * and the count of paid modules. Uses ONLY the amount_display strings supplied
 * from the backend (no hardcoding of prices).
 *
 * Returns null when we can't compute (missing inputs).
 */
export function bundleSavings({ unitDisplay, bundleDisplay, paidCount }) {
  const unit = parseAmount(unitDisplay);
  const bundle = parseAmount(bundleDisplay);
  if (unit == null || bundle == null || !paidCount) return null;
  const gross = unit * paidCount;
  const saves = Math.max(0, gross - bundle);
  return {
    unit,
    bundle,
    gross,
    saves,
    // e.g. "$4.99 × 14 = $69.86  →  Bundle $29 (save $40.86)"
    formatEn: `${unitDisplay} × ${paidCount} = $${gross.toFixed(2)}  →  Bundle ${bundleDisplay} (save $${saves.toFixed(2)})`,
    formatAr: `${unitDisplay} × ${paidCount} = $${gross.toFixed(2)}  ←  الباقة ${bundleDisplay} (توفير $${saves.toFixed(2)})`,
  };
}
